module.exports = __webpack_public_path__ + "img/1.afd2aa53.jpg";